// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.0.3 (commit 5836c268a7307f864b33636357b0869ecc40bc0a).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import TypeExportReducer from "./type_export_reducer";
import SaveEventsReducer from "./save_events_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AccountsRow from "./accounts_table";
import DepositsRow from "./deposits_table";
import EventsRow from "./events_table";
import LatestBlockRow from "./latest_block_table";
import LatestConfirmedBlockRow from "./latest_confirmed_block_table";
import MarketsRow from "./markets_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  accounts: __table({
    name: 'accounts',
    indexes: [
      { name: 'account_id', algorithm: 'btree', columns: [
        'accountId',
      ] },
    ],
    constraints: [
      { name: 'accounts_account_id_key', constraint: 'unique', columns: ['accountId'] },
    ],
  }, AccountsRow),
  deposits: __table({
    name: 'deposits',
    indexes: [
      { name: 'request_id', algorithm: 'btree', columns: [
        'requestId',
      ] },
    ],
    constraints: [
      { name: 'deposits_request_id_key', constraint: 'unique', columns: ['requestId'] },
    ],
  }, DepositsRow),
  events: __table({
    name: 'events',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'events_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, EventsRow),
  latest_block: __table({
    name: 'latest_block',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'latest_block_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LatestBlockRow),
  latest_confirmed_block: __table({
    name: 'latest_confirmed_block',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'latest_confirmed_block_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LatestConfirmedBlockRow),
  markets: __table({
    name: 'markets',
    indexes: [
      { name: 'key', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'markets_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, MarketsRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("type_export", TypeExportReducer),
  __reducerSchema("save_events", SaveEventsReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.0.3" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

